module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"dataTypes":"Veri Tipleri","dataTypeForHeating":"Yakıt için veri tipi","siteCode":"Kod","update location":"Lokasyon Güncelleme","site name":"Lokasyon adı","is open":"Açık mı?","includeInEmissionsCalculations":"Emisyon hesaplarına dahil et","coordinates":"Koordinatlar"},"en":{"dataTypes":"Data Types","dataTypeForHeating":"Data Type for Heating","siteCode":"Code","update location":"Update Location","site name":"Site Name","is open":"Is Open?","includeInEmissionsCalculations":"Include in Emissions Calculations","coordinates":"Coordinates"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Setting/SiteEdit.vue
// module id = bnVc
// module chunks = 1